function deepClone(obj, newObj = {}) {
    for (let key in obj) {
        if (typeof obj[key] == 'object') {
            newObj[key] = (obj[key].constructor === Array) ? [] : {}
            deepClone(obj[key], newObj[key]);
        } else {
            newObj[key] = obj[key]
        }
    }
    return newObj;
}


// 自定义过滤器
function isTrue(flag) {
    return flag === '1' || flag === 1;
}


function isListEmpty(list) {
    if (list) {
        // 列表长度为0
        return list.length === 0;
    } else {
        // 列表不存在
        return true
    }
}

const formatDurationMinute = (sections) => {
    if (sections == null) return '0分钟';
    if (sections >= 60) {
        let minute = parseInt(sections / 60);
        return minute + '分钟';
    }else {
        return sections + "秒"
    }
};

export {
    deepClone, isTrue, isListEmpty,formatDurationMinute
}
